export default "__VITE_ASSET__CMduj9rz__"